// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"1e3d0370","405":"76593109"}[chunkId] + ".chunk.js";
};